export default "__VITE_ASSET__Wc1$2YNq__"